/** Keep digits and a single decimal point while typing a product list price. */
export function filterPriceInput(raw: string): string {
  const cleaned = String(raw ?? "").replace(/[^\d.]/g, "");
  const dot = cleaned.indexOf(".");
  if (dot === -1) {
    return cleaned;
  }
  return cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, "");
}

/** Blank or a non-negative decimal; otherwise null. */
export function normalizePriceInput(raw: string): string | null {
  const trimmed = filterPriceInput(raw).trim();
  if (trimmed === "" || trimmed === ".") {
    return "";
  }
  const amount = trimmed.endsWith(".") ? trimmed.slice(0, -1) : trimmed;
  if (!/^\d+(\.\d+)?$/.test(amount)) {
    return null;
  }
  const value = Number(amount);
  if (!Number.isFinite(value) || value < 0) {
    return null;
  }
  return amount;
}
